import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const useTaglinesStyles = makeStyles({
  body: {
    ...typographyStyles.body1,
    marginTop: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground1,
  },
  loading: {
    marginBottom: tokens.spacingVerticalL,
  },
  loadingItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: tokens.spacingVerticalL,
    ...shorthands.gap(tokens.spacingHorizontalS, tokens.spacingHorizontalNone),
  },
  taglineItem: {
    display: 'flex',
    marginBottom: tokens.spacingVerticalL,
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    ...shorthands.gap(tokens.spacingHorizontalS, tokens.spacingHorizontalNone),

    '& button:not(:disabled)': {
      '&:hover': {
        '& span': {
          color: `${tokens.colorPaletteRedBackground3} !important`,
        },
      },
    },
  },
  taglineItemInput: {
    display: 'flex',
    ...shorthands.flex(1),
    flexDirection: 'column',
    justifyContent: 'flex-end',

    '& span': {
      marginTop: tokens.spacingVerticalXXS,
      color: tokens.colorNeutralForeground3,
    },
  },
});
